import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const projectTypeMap: Record<ProjectType, MapItem> = {
  renovation: { label: 'Renovation' },
  new_construction: { label: 'New Construction' },
  repairs: { label: 'Repairs' },
  additions: { label: 'Additions' },
  landscaping_outdoor: { label: 'Landscaping/Outdoor' },
  other: { label: 'Other' },
}

// Schema that includes both the type and optional custom value
export const projectTypeSchema = z.enum(Object.keys(projectTypeMap) as [ProjectType, ...ProjectType[]])

export type ProjectType = 'renovation' | 'new_construction' | 'repairs' | 'additions' | 'landscaping_outdoor' | 'other'
